<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="usersLoaderModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-sm" style="top: 40%;">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-fluid">
              <div class="row">
                <div class="col-md-12">
                  <center>
                    <img src="static/assets/images/ajax-loader.gif" /> deleting, please wait..
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage users</small>
      </legend>
      <div></div>
      <div>
        <div class="usersLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px;color:blue"></i> loading users...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemUsers"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Account_status'">
              {{ props.row.Account_status === 0 ?
                'Pending': 
                props.row.Account_status === 1 ?
                'Active' :
                props.row.Account_status === 2 ? 
                'Disabled' :
                props.row.Account_status === 3 ?
                'inActive' : 
              ''}}
            </span>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
           
            <span v-if="props.column.field == 'Action'">
              <button class="btn btn-primary btn-sm" @click="userRoles(props.row.id)">
                <i class="fa fa-key"></i>
              </button>

              <button class="btn btn-info btn-sm" @click="viewUser(props.row.id)">
                <i class="fa fa-edit"></i>
              </button>

              <button class="btn btn-danger btn-sm" @click="deleteUser(props.row.id)">
                <i class="fa fa-trash"></i>
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      columns: [
        {
          label: " Fullnames",
          field: "fullname",
          type: "text"
        },
        {
          label: "Email",
          field: "email",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter email"
          }
        },
        {
          label: " Profilename",
          field: "profilename",
          type: "text"
        },
        {
          label: " Gender",
          field: "gender",
          type: "text"
        },
        {
          label: "Account status",
          field: "Account_status",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadUsers();
  },
  computed: {
    ...mapGetters(["systemUsers"])
  },
  methods: {
    ...mapActions(["loadUsers", "viewUser", "deleteUser","userRoles"])
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/users/manageusers.vue